import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';

import { ReactComponent as LogoIcon } from '../assets/Logo.svg';
import HeaderBgr from '../assets/header_bg.png';
import { useThemeContext } from 'contexts/ThemeContext';
import { useAppContext } from 'contexts/AppContext';
import { BiLeftArrowAlt } from 'react-icons/bi';
import HomeIcon from '@mui/icons-material/Home';
import { createTheme, ThemeProvider, IconButton, Box, Typography, Divider } from '@mui/material';
import { InitState, LocalStorageText } from '../constants/common.js';
import { loginObservable } from '../common/observable.js';

const HomeButton = (props) => {
  const navigate = useNavigate();
  const { getUserInfo } = useAppContext();

  return (
    <Box>
      <IconButton
        onClick={() => {
          const user = getUserInfo();
          if (user) {
            if (user.permissions.includes('DIGIIN_SELLER')) {
              navigate('/sale');
            } else {
              navigate('/');
            }
          } else {
            navigate('/home-customer');
          }
        }}
      >
        <HomeIcon color="textColor" />
      </IconButton>
    </Box>
  );
};

const headerStyle = ({ isLight, mainColor, defaultColor }) => css`
  z-index: 1;
  position: sticky;
  background-color: ${mainColor === defaultColor ? 'var(--body-bgr)' : mainColor};
  background-image: ${mainColor === defaultColor ? 'url(' + HeaderBgr + ')' : 'none'};
  background-size: 100%;
  top: 0;
  padding: 0.65rem 10px 0 10px;
  color: var(--color-white);
  font-weight: 700;

  & > nav {
    height: 100%;
    display: flex;
    margin: 0px 0px;
    max-width: 480px;
    align-items: center;
    justify-content: flex-start;
    .boxLeft {
      width: 20%;
      display: flex;
      margin-left: 0px;
      justify-content: flex-start;
    }
    .boxRight {
      width: 80%;
      display: flex;
      margin: 0px;
      align-items: center;
      justify-content: flex-end;
    }
    .topRight-btn {
      justify-content: center;
      white-space: pre;
      margin-right: 10px;
      .login-btn {
        display: flex;
        align-items: center;
        padding-left: 10px;
      }
    }

    .logo1 a {
      height: 100%;
      display: flex;
      align-items: flex-start;
      margin-left: 0px !important;
      //font-weight: bold;
      //text-decoration: none;
      //text-transform: uppercase;

      svg {
        width: 100%;
        height: 32px;
      }
    }

    svg.theme {
      cursor: pointer;
      display: flex;
      user-select: none;
    }
  }
`;

const theme = createTheme({
  palette: {
    textColor: {
      main: '#fff',
    },
  },
  components: {
    MuiBadge: {
      styleOverrides: {
        colorError: {
          fontWeight: 700,
          fontSize: 9,
        },
        badge: {
          height: 15,
        },
      },
    },
  },
  typography: {
    headerLinkName: {
      fontWeight: 'normal !important',
      fontSize: '1rem !important',
      marginLeft: '1rem !important',
    },
  },
});

const getRouteName = (pathName, fnol = '', query) => {
  if (query?.get('hideHeader') === 'true') return null;
  const mainPathName = pathName.split('/')[1];
  if (mainPathName.includes('contract-detail')) return 'Chi tiết hợp đồng ' + fnol;
  if (mainPathName.includes('create-claim')) return 'Tạo yêu cầu bồi thường HD ' + fnol;
  if (mainPathName.includes('claim-detail')) return 'Chi Tiết Bồi Thường ' + fnol;
  if (mainPathName.includes('claim-info')) return 'Thông Tin Bồi Thường ' + fnol;
  if (mainPathName.includes('upload-license')) return 'Thông tin chứng từ ' + fnol;
  switch (mainPathName) {
    case 'register':
      return 'Đăng ký';
    case 'forgot-password':
      return 'Quên mật khẩu';
    case 'ep-claim':
      return 'Chi Tiết Bồi Thường ' + fnol;
    case 'ep-claim-create':
      return 'Tạo yêu cầu bồi thường ' + fnol;
    case 'amp-claim-create':
      return 'Tạo yêu cầu bồi thường ' + fnol;
    case 'pcs-claim-create':
      return 'Tạo yêu cầu bồi thường ' + fnol;
    case 'claim-momo':
      return 'Chi Tiết Bồi Thường ' + fnol;
    case 'claim-guide':
      return 'Hướng dẫn gửi yêu cầu bồi thường';
    case 'confirm-email':
      return 'Xác Thực Email';
    case 'verify-email':
      return 'Xác Thực Email';
    case 'user-info':
      return 'Thông tin cá nhân';
    case 'password':
      return 'Mật khẩu';
    case 'notification':
      return 'Thông Báo';
    case 'benefits':
      return 'Quyền lợi bảo hiểm';
    case 'qna':
      return 'Hỏi Và Đáp';
    case 'change-password':
      return 'Quên Mật Khẩu';
    case 'contract-2-wheel-detail':
      return 'Chi tiết hợp đồng xe máy ' + fnol;
    case '2wheel-claim-momo':
      return 'Chi Tiết Bồi Thường ' + fnol;
    case 'create-2-wheel-claim-momo':
      return 'Tạo yêu cầu bồi thường ' + fnol;
    case 'claim-2-wheel-info':
      return 'Thông Tin Bồi Thường ' + fnol;
    case 'claim-2-wheel-info-momo':
      return 'Thông Tin Bồi Thường ' + fnol;
    case 'verify-sms':
      return 'Xác Thực OTP';
    case 'verify-sms-momo':
      return 'Xác Thực OTP';
    case 'claim-4-wheel-info':
      return 'Thông Tin Bồi Thường ' + fnol;
    case '4wheel-claim':
      return 'Chi tiết yêu cầu bồi thường ' + fnol;
    case '4wheel-claim-create-mono':
      return 'Tạo yêu cầu bồi thường ' + fnol;
    case 'claim-security':
      return 'Chính sách';
    case 'ewi-claim':
      return 'Chi Tiết Bồi Thường ' + fnol;
    case 'chinh-sach-bao-mat-du-lieu-ca-nhan':
      return true;
    default:
      return null;
  }
};
const isHideBackBtn = (pathName) => {
  const mainPathName = pathName.split('/')[1];
  if (
    mainPathName === 'upload-license-4-wheel' ||
    mainPathName === '4wheel-claim-upload-license-momo'
  ) {
    return pathName.split('/')[2] == 'add';
  }
  if (mainPathName === 'upload-license') {
    return pathName.split('/')[2] == 'add';
  }
  if (mainPathName === 'upload-license-momo') {
    return pathName.split('/')[2] == 'add';
  }
  const pages = [
    'claim-momo',
    'ep-claim',
    '4wheel-claim',
    '4wheel-claim-create-mono',
    'create-2-wheel-claim-momo',
    '2wheel-claim-momo',
    'claim-detail-yab',
    'claim-detail-ybb',
    'chinh-sach-bao-mat-du-lieu-ca-nhan',
  ];
  return pages.includes(mainPathName);
};
const isShowIcon = (pathName) => {
  const mainPathName = pathName.split('/')[1];
  const pages = ['chinh-sach-bao-mat-du-lieu-ca-nhan'];
  return pages.includes(mainPathName);
};
const Header = ({ loginSuccess }) => {
  const location = useLocation();
  const query = React.useMemo(() => new URLSearchParams(location.search), [location.search]);
  const hideHeader = query?.get('hideHeader') === 'true';
  const navigate = useNavigate();
  const { isLight, mainColor, defaultColor } = useThemeContext();
  const { fnol, getUserInfo } = useAppContext();
  const isCustomer = getUserInfo();
  const token = localStorage.getItem(LocalStorageText.Token);
  const [authenticated, setAuthenticated] = useState(token && token !== InitState);
  const renderLoginRegister = () => {
    const isLoginPage =
      location.pathname.split('/')[1] === 'login' || location.pathname.split('/')[1] === 'register';
    if (isLoginPage || hideHeader) return '';
    return (
      <>
        <Link to="/login" style={{ textDecoration: 'none' }}>
          <span style={{ color: 'white', fontWeight: 'bold' }}>Đăng nhập</span>
        </Link>
        <Divider orientation="vertical" flexItem sx={{ mx: 1 }}></Divider>
        <Link to="/register" style={{ textDecoration: 'none' }}>
          <span style={{ color: 'white', fontWeight: 'normal' }}>Đăng ký</span>
        </Link>
      </>
    );
  };

  useEffect(() => {
    loginObservable.subscribe((value) => {
      setAuthenticated(value && value !== InitState);
    });
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <header
        css={[headerStyle({ isLight, mainColor, defaultColor })]}
        style={authenticated ? { height: 60 } : {}}
      >
        {getRouteName(location.pathname, fnol, query) ? (
          <nav>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                my: isHideBackBtn(location.pathname) ? 1 : 0,
              }}
            >
              {!isHideBackBtn(location.pathname) && (
                <IconButton onClick={() => navigate(-1)}>
                  <BiLeftArrowAlt size={32} color="white" />
                </IconButton>
              )}
              {isShowIcon(location.pathname) && (
                <div className="logo1">
                  <Link to="#">
                    <LogoIcon fill="white" />
                  </Link>
                </div>
              )}
              <Typography variant="headerLinkName">
                {getRouteName(location.pathname, fnol, query)}
              </Typography>
            </Box>
          </nav>
        ) : loginSuccess && location.pathname.split('/')[1] != 'compulsory-oto' ? (
          <nav style={{ width: '100%' }}>
            <div className={'boxLeft'}>
              <div className="logo1">
                {!hideHeader && (
                  <Link to="/" replace={location.pathname === '/'}>
                    <LogoIcon fill="white" />
                  </Link>
                )}
              </div>
            </div>
            <div className={'boxRight'}>
              <div className={'topRight-btn'}>
                {authenticated ? (
                  <div className={'login-btn'}>{isCustomer && <HomeButton />}</div>
                ) : (
                  <div className={'login-btn'}>
                    {!isCustomer ? renderLoginRegister() : <HomeButton />}
                  </div>
                )}
              </div>
            </div>
          </nav>
        ) : (
          ''
        )}
      </header>
    </ThemeProvider>
  );
};

export default Header;
